import { EcoChallengeFilesApiService } from '@/common/services/eco-challenge-files.api.service';
import { EcoChallengeFileModel } from "@/common/models/eco-challenge-file.model";
import REQUEST_STATUS from '../../common/enums/requestStatus';

export default {
  namespaced: true,
  state: {
    status: "",
    items: [],
    item: "",
    attachments: [],
    checkedFiles: [],
  },

  getters: {
    getAllItems: state => state.items,
    getStatus: state => state.status,
    getItem: state => state.item,
    getAllAttachments: state => state.attachments,
    getCheckedFiles: state => state.checkedFiles,
  },

  mutations: {
    SET_ITEMS(state, data) {
      state.items = data;
    },
    SET_ITEM(state, data) {
      state.item = data;
    },
    FETCH_REQUEST(state) {
      state.status = REQUEST_STATUS.LOADING;
    },
    FETCH_SUCCESS(state) {
      state.status = REQUEST_STATUS.SUCCESS;
    },
    FETCH_FAIL(state) {
      state.status = REQUEST_STATUS.FAIL;
    },
    SET_ATTACHMENTS(state, data) {
      state.attachments = data;
    },
    SET_CHECKED_FILE(state, data) {
      state.checkedFiles.push(data);
    },
  },

  actions: {
    fetchAllItems({ commit, dispatch }) {
      commit('FETCH_REQUEST');

      return EcoChallengeFilesApiService.getAll(builder => {
        builder.embed([
          EcoChallengeFileModel.EMBED_ECO_CHALLENGE_FILE_ORDERS_COUNT,
          EcoChallengeFileModel.EMBED_USER,
          EcoChallengeFileModel.EMBED_ATTACHMENT
        ]);
        builder.turnOffPagination();
      })
        .then(response => {
          const items = response.getItems();
          commit('SET_ITEMS', items);
          if (items.length){
            commit('FETCH_SUCCESS');
          } else {
            commit('FETCH_FAIL');
          }
        })
        .catch(response => {
          dispatch('handleError', response);
        });
    },

    fetchItem({ commit, dispatch }, id) {
      commit('FETCH_REQUEST');

      return EcoChallengeFilesApiService.get(id, builder => {
        builder.embed([
          EcoChallengeFileModel.EMBED_ECO_CHALLENGE_FILE_ORDERS_COUNT,
          EcoChallengeFileModel.EMBED_USER,
          EcoChallengeFileModel.EMBED_ATTACHMENT
        ]);
      })
        .then(response => {
          commit('SET_ITEM', response.getItem());
          commit('FETCH_SUCCESS');
        })
        .catch(response => {
          dispatch('handleError', response);
        });
    },

    createItem({ commit, dispatch }, data) {
      commit('FETCH_REQUEST');

      return EcoChallengeFilesApiService.post(data, builder => {
        builder.embed([
          EcoChallengeFileModel.EMBED_ECO_CHALLENGE_FILE_ORDERS_COUNT,
          EcoChallengeFileModel.EMBED_USER,
          EcoChallengeFileModel.EMBED_ATTACHMENT
        ]);
      })
        .then(response => {
          commit('SET_ITEM', response.getItem());
          commit('FETCH_SUCCESS');
        })
        .catch(response => {
          dispatch('handleError', response);
        });
    },

    setAttachments({ commit }, data) {
      commit("SET_ATTACHMENTS", data);
    },

    setCheckedFile({ commit }, file) {
      commit("SET_CHECKED_FILE", file);
    },

    handleError({ commit }, response) {
      commit('FETCH_FAIL');
      const message = response.getFirstValidationErrorMessage() || response.getMessage();
      this.$app.$alertError(message);
    },
  },
};
